var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "user-info-panel" }, [
    _vm.isLogin && _vm.userInfo.isLogin === true
      ? _c("div", { staticClass: "logged-in" }, [
          _c(
            "a",
            {
              staticClass: "name",
              attrs: { target: "_blank", href: "https://space.bilibili.com/" },
            },
            [_vm._v(_vm._s(_vm.userInfo.uname))]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "type",
              attrs: {
                target: "_blank",
                href: "https://account.bilibili.com/account/big",
              },
            },
            [_vm._v(_vm._s(_vm.userType))]
          ),
          _vm._v(" "),
          _vm.userInfo.vipStatus === 1 && _vm.userInfo.vipType === 2
            ? _c("div", { staticClass: "privileges row" }, [
                _c(
                  "div",
                  {
                    staticClass: "b-coin",
                    class: { received: _vm.privileges.bCoin.received },
                    attrs: {
                      title: "有效期限: " + _vm.privileges.bCoin.expire,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.privilegeReceive(1)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.privileges.bCoin.received
                            ? "已领取B币"
                            : "领取B币"
                        ) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "coupons",
                    class: { received: _vm.privileges.coupons.received },
                    attrs: {
                      title: "有效期限: " + _vm.privileges.coupons.expire,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.privilegeReceive(2)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.privileges.coupons.received
                            ? "已领取优惠券"
                            : "领取优惠券"
                        ) +
                        "\n      "
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "level-info row" }, [
            _c(
              "a",
              {
                staticClass: "level",
                attrs: {
                  target: "_blank",
                  title: "等级",
                  href: "https://account.bilibili.com/account/record",
                },
              },
              [
                _vm.userInfo.is_senior_member
                  ? _c("VIcon", {
                      staticClass: "level-icon plus",
                      attrs: {
                        icon:
                          "lv" +
                          _vm.userInfo.level_info.current_level +
                          "-plus",
                        colored: "",
                        size: 30,
                      },
                    })
                  : _c("VIcon", {
                      staticClass: "level-icon",
                      attrs: {
                        icon: "lv" + _vm.userInfo.level_info.current_level,
                      },
                    }),
              ],
              1
            ),
            _vm._v(" "),
            _c("span", { staticClass: "level-progress-label" }, [
              _vm._v(
                _vm._s(_vm.userInfo.level_info.current_exp) +
                  " / " +
                  _vm._s(_vm.userInfo.level_info.next_exp)
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "level-progress separator" }, [
            _c("div", {
              staticClass: "level-progress-thumb",
              style: _vm.levelProgressStyle,
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "items" }, [
            _c(
              "a",
              {
                staticClass: "item",
                attrs: {
                  target: "_blank",
                  title: "手机验证",
                  href: "https://passport.bilibili.com/account/security#/bindphone",
                },
              },
              [
                _c("VIcon", { attrs: { icon: "bind-phone", size: 20 } }),
                _vm._v(" "),
                _vm.userInfo.mobile_verified
                  ? _c("VIcon", { attrs: { icon: "ok", size: 18 } })
                  : _c("VIcon", { attrs: { icon: "cancel", size: 18 } }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "item",
                attrs: {
                  target: "_blank",
                  title: "邮箱验证",
                  href: "https://passport.bilibili.com/account/security#/bindmail",
                },
              },
              [
                _c("VIcon", { attrs: { icon: "bind-email", size: 20 } }),
                _vm._v(" "),
                _vm.userInfo.email_verified
                  ? _c("VIcon", { attrs: { icon: "ok", size: 18 } })
                  : _c("VIcon", { attrs: { icon: "cancel", size: 18 } }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "item",
                attrs: {
                  target: "_blank",
                  href: "https://account.bilibili.com/site/coin",
                  title: "硬币",
                },
              },
              [
                _c("VIcon", { attrs: { icon: "coin-outline", size: 20 } }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.userInfo.money))]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "item",
                attrs: {
                  target: "_blank",
                  href: "https://pay.bilibili.com/bb_balance.html",
                  title: "B币",
                },
              },
              [
                _c("VIcon", { attrs: { icon: "b-coin-outline", size: 20 } }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.userInfo.wallet.bcoin_balance))]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "separator" }),
          _vm._v(" "),
          _c("div", { staticClass: "stats" }, [
            _c(
              "a",
              {
                staticClass: "stats-item",
                attrs: {
                  href:
                    "https://space.bilibili.com/" +
                    _vm.userInfo.mid +
                    "/fans/follow",
                  target: "_blank",
                },
              },
              [
                _c("div", { staticClass: "stats-number" }, [
                  _vm._v(_vm._s(_vm._f("count")(_vm.stat.following))),
                ]),
                _vm._v("\n        关注\n      "),
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "stats-item",
                attrs: {
                  href:
                    "https://space.bilibili.com/" +
                    _vm.userInfo.mid +
                    "/fans/fans",
                  target: "_blank",
                },
              },
              [
                _c("div", { staticClass: "stats-number" }, [
                  _vm._v(_vm._s(_vm._f("count")(_vm.stat.follower))),
                ]),
                _vm._v("\n        粉丝\n      "),
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "stats-item",
                attrs: {
                  href:
                    "https://space.bilibili.com/" +
                    _vm.userInfo.mid +
                    "/dynamic",
                  target: "_blank",
                },
              },
              [
                _c("div", { staticClass: "stats-number" }, [
                  _vm._v(_vm._s(_vm._f("count")(_vm.stat.dynamic_count))),
                ]),
                _vm._v("\n        动态\n      "),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "separator" }),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "bv-custom-navbar-operation",
              attrs: {
                target: "_blank",
                href: "https://account.bilibili.com/account/home",
              },
            },
            [
              _c("VIcon", { attrs: { icon: "profile" } }),
              _vm._v("个人中心\n    "),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "bv-custom-navbar-operation",
              attrs: {
                target: "_blank",
                href: "https://member.bilibili.com/platform/upload-manager/article",
              },
            },
            [
              _c("VIcon", { attrs: { icon: "posts" } }),
              _vm._v("投稿管理\n    "),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "bv-custom-navbar-operation",
              attrs: { target: "_blank", href: "https://pay.bilibili.com/" },
            },
            [
              _c("VIcon", { attrs: { icon: "wallet" } }),
              _vm._v("B币钱包\n    "),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "bv-custom-navbar-operation",
              attrs: {
                target: "_blank",
                href: "https://link.bilibili.com/p/center/index",
              },
            },
            [
              _c("VIcon", { attrs: { icon: "live-center" } }),
              _vm._v("直播中心\n    "),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "bv-custom-navbar-operation",
              attrs: {
                target: "_blank",
                href: "https://show.bilibili.com/orderlist",
              },
            },
            [
              _c("VIcon", { attrs: { icon: "order-center" } }),
              _vm._v("订单中心\n    "),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "bv-custom-navbar-operation",
              attrs: {
                target: "_blank",
                href: "https://www.bilibili.com/v/cheese/mine",
              },
            },
            [
              _c("VIcon", { attrs: { icon: "course" } }),
              _vm._v("我的课程\n    "),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "logout grey-button",
              on: {
                click: function ($event) {
                  return _vm.logout()
                },
              },
            },
            [_vm._v("退出登录")]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isLogin
      ? _c("div", { staticClass: "not-logged-in" }, [
          _c("h1", { staticClass: "welcome" }, [_vm._v("欢迎来到 bilibili")]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "signup grey-button",
              attrs: {
                href: "https://passport.bilibili.com/register/phone.html",
              },
            },
            [_vm._v("注册")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "login theme-button",
              attrs: { href: "https://passport.bilibili.com/login" },
            },
            [_vm._v("登录")]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }